export default "__VITE_ASSET__CU$SouF$__"